<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.61738 17L6.34728 17.6531C8.28911 19.5959 11.0919 20.4066 13.771 19.8004C16.4502 19.1942 18.6309 17.2559 19.5473 14.6664C19.7315 14.1458 20.3029 13.873 20.8236 14.0573C21.3442 14.2415 21.617 14.8129 21.4327 15.3336C20.2873 18.5705 17.5613 20.9934 14.2124 21.7511C10.8635 22.5088 7.36 21.4954 4.97354 19.1055L4 18.2353V22C4 22.5523 3.55228 23 3 23C2.44772 23 2 22.5523 2 22V16C2 15.4477 2.44772 15 3 15H9C9.55228 15 10 15.4477 10 16C10 16.5523 9.55228 17 9 17H5.61738ZM20 5.76474V2C20 1.44772 20.4477 1 21 1C21.5523 1 22 1.44772 22 2V8C22 8.55228 21.5523 9 21 9H15C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7H18.3826L17.6527 6.34693C15.7109 4.40413 12.9081 3.59342 10.229 4.1996C7.54984 4.80579 5.36906 6.7441 4.45272 9.3336C4.26848 9.85424 3.69705 10.127 3.1764 9.94272C2.65576 9.75848 2.38304 9.18705 2.56728 8.6664C3.71271 5.42953 6.43869 3.00665 9.7876 2.24891C13.1365 1.49118 16.64 2.50457 19.0265 4.89446L20 5.76474Z"
      fill="#0F2D5A"
    />
  </svg>
</template>
